"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _classnames = _interopRequireDefault(require("classnames"));

var _hover = require("../../hooks/hover");

var ThreadItemAvatar = function ThreadItemAvatar(_ref) {
  var quickAction = _ref.quickAction,
      children = _ref.children;

  var _useHover = (0, _hover.useHover)(),
      hovered = _useHover.hovered,
      targetProps = _useHover.targetProps;

  var showQuickAction = hovered && !(0, _isNil["default"])(quickAction);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, targetProps, {
    className: "relative flex items-center w-full h-full"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('absolute left-0 top-0', {
      'z-10': showQuickAction,
      invisible: !showQuickAction
    })
  }, quickAction), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('absolute left-0 top-0', {
      'z-10': !showQuickAction,
      invisible: showQuickAction
    })
  }, children));
};

var _default = /*#__PURE__*/(0, _react.memo)(ThreadItemAvatar);

exports["default"] = _default;
//# sourceMappingURL=index.js.map